import { firebase } from '../firebase/firebase';

const sendNoticeFunction = firebase.functions().httpsCallable('httpsDashboardSendNotice');

export const sendNotice = (body, subject) => {
  return (dispatch, getState) => {
    const place = getState().place.uid;
    return sendNoticeFunction({body, place, subject});
  };
};